<block-ui style="z-index:999999;" [delayStart]="200" [delayStop]="500">
    <router-outlet></router-outlet>
</block-ui>